const isPlainObject = (v) => v !== null && typeof v === 'object' && !Array.isArray(v);

// Mezcla lo que devuelve la API sobre los valores por defecto. Una respuesta
// puede traer la configuración incompleta (o ninguna); sin esto los
// formularios leen propiedades de undefined y la página queda en blanco, o
// reciben null en inputs controlados. Los valores null/undefined de la API se
// ignoran (gana el valor por defecto) y los arreglos se reemplazan completos.
export const mergeDefaults = (base, incoming) => {
  if (!isPlainObject(incoming)) return base;
  const result = { ...base };
  Object.keys(incoming).forEach((key) => {
    const value = incoming[key];
    if (value === undefined || value === null) return;
    result[key] = isPlainObject(base[key]) && isPlainObject(value)
      ? mergeDefaults(base[key], value)
      : value;
  });
  return result;
};

export { isPlainObject };
